export class Column {
    id:string;
    table_name:string;
    table_type:string;
    column_name:string;
    column_type:string;
    label:string;
    options;
    is_required:string;
    grid_size:string;    
}